import React, { Component } from "react";
import { Container, Form, Button, Card, Spinner } from "react-bootstrap";
import './Images.css';

import { Configuration, OpenAIApi } from 'openai'; 

const configuration = new Configuration({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY
});
const openai = new OpenAIApi(configuration);

class Images extends Component {
    constructor() {
        super();
        this.state = {
            heading: "The image will appear here",
            response: "...creating image...",
            size: "large",
            generatedText: "Aphorism and image will appear here...",
            isLoadingText: false,
            isLoadingImage: false
        };
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        this.setState({ isLoadingText: true });

       
      

        openai.createCompletion({
           
                model: "text-davinci-003",
                prompt: 
                `Create an aphorism in the of Wittgenstein's  The Tractatus Logico-Philosophicus (widely abbreviated and cited as TLP) is the only book-length philosophical work by the Austrian philosopher Ludwig Wittgenstein that was published during his lifetime. The project had a broad goal: to identify the relationship between language and reality and to define the limits of science.[1] Wittgenstein wrote the notes for the Tractatus while he was a soldier during World War I and completed it during a military leave in the summer of 1918. It was originally published in German in 1921 as Logisch-Philosophische Abhandlung (Logical-Philosophical Treatise). In 1922 it was published together with an English translation and a Latin title, which was suggested by G. E. Moore as homage to Baruch Spinoza's Tractatus Theologico-Politicus (1670).The Tractatus is written in an austere and succinct literary style, containing almost no arguments as such, but consists of altogether 525 declarative statements, which are hierarchically numbered. So, you create an afforism in the style of Wittgenstein's Tractatus numbered after the last statement:  > 225.`,
              
                temperature: 0.8,
                max_tokens: 300,
                top_p: 1,
                frequency_penalty: 0,
                presence_penalty: 0,
               
            }).then((response) => {
                this.setState({
                    generatedText: `${response.data.choices[0].text}`,
                    isLoadingText: false,
                }, () => {
                    this.setState({ isLoadingImage: true });
                    openai.createImage({
                    prompt: `recursive image in the style of escher, moebius stript ${response.data.choices[0].text}`,
                    n: 1,
                    size: this.state.size === "large" ? "1024x1024" : this.state.size === "medium" ? "512x512" : "256x256",
                }).then((response) => {
                    this.setState({
                      
                        response: `${response.data.data[0].url}`,
                        isLoadingImage: false
                    });
                }).catch((error) => {
                    console.log(error);
                });
            });
        }).catch((error) => {
            console.log(error);
        });
    }

    handleSizeChange = (e) => {
        this.setState({ size: e.target.value });
    }

    render() {
        return (
            <div className="images">
                 
                <Container className="images-container">
                <h2>Infinite Tractatus</h2>
                   
                    <p className="subtitle-text">
                    "Infinite Tractatus delves deep into Wittgenstein's exploration of language's limits and reality. Emulating his "Tractatus Logico-Philosophicus," the app recursively generates aphorisms and images, reflecting on the very nature of understanding and the boundaries of Large Language Models and AI. It mirrors Wittgenstein's philosophical pursuits, exploring the boundaries between human thought and machine generation."
                    </p>
                    <Form onSubmit={this.onFormSubmit} className="form-inline">
    <Form.Group controlId="formSize" className="form-group">
       
    </Form.Group>
    <Button className="vintage-button" type="submit">Generate</Button>

</Form>

                    <Card className="images-card rounded-card">
                        <Card.Body>
                            <Card.Text className="images-text">
                                {this.state.isLoadingText ? (
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only"><div class="lds-hourglass"></div></span>
                                    </Spinner>
                                ) : (
                                    <p className="generated-text">{this.state.generatedText}</p>
                                )}
                                {this.state.isLoadingImage ? (
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only"><div class="lds-hourglass"></div></span>
                                    </Spinner>
                                ) : (
                                    <div className="image-wrapper">
                                        <a 
                                            className="image-link"
                                            download="artifact"
                                            rel="noreferrer"
                                            href={this.state.response}
                                            target="_blank">
                                          <img 
    className={`generated-image ${this.state.isLoadingImage ? '' : 'loaded'}`} 
    src={this.state.response} 
    alt=''/>
                                        </a>
                                    </div>
                                )}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        );
    }
}

export default Images;